var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11.3126V5.31262C11 4.76034 11.4477 4.31262 12 4.31262C12.5523 4.31262 13 4.76034 13 5.31262V11.3126H19C19.5523 11.3126 20 11.7603 20 12.3126C20 12.8649 19.5523 13.3126 19 13.3126H13V19.3126C13 19.8649 12.5523 20.3126 12 20.3126C11.4477 20.3126 11 19.8649 11 19.3126V13.3126H5C4.44772 13.3126 4 12.8649 4 12.3126C4 11.7603 4.44772 11.3126 5 11.3126H11Z",
    fill: "#314071"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.b55161898d3d2cb0e2f2720738c8fdd8.svg";
export { ForwardRef as ReactComponent };